import React, { Component } from 'react'

// Just an empty component so that the toolbar button shows up
// The actual button click is handled differently from the rest of toolbar buttons
export default class FavouriteDesk extends Component {
    render() {
        return <div />
    }
}
